import { get } from 'helpers/api';

const rootPath = '/users';

export function searchUsers(searchTerm) {
  return get(`${rootPath}/search`, {
    params: {
      "q[first_name_or_last_name_or_login_credential_email_cont]": searchTerm
    }
  });
}

export function getBrokers() {
  return get(`${rootPath}/brokers`);
}
